<app-admin-boilerplate>
    @if (event$ | async; as lrpEvent){
        <app-event-headline [event]="lrpEvent" />
        <div class="grid grid-cols-2 gap-4" [formGroup]="detailsForm">
            <div class="w-full">
                <h2>Event Details</h2>
                <hr>
                <div class="flex flex-col gap-2 w-full mb-3">
                    <label for="eventName">Event Name</label>
                    <input id="eventName" formControlName="name" [title]=""/>
                    @if (lrpEvent.name !== ''){
                        <small class="ms-6">This will be displayed as: <i>
                            {{ lrpEvent.eventHost.eventSystem.name }}
                            @if (lrpEvent.eventHost.display){
                                - {{ lrpEvent.eventHost.name}}
                            } | {{ lrpEvent.name }}</i>
                        </small>
                    }
                </div>
                <div class="grid grid-cols-2 gap-4 mb-3">
                    <div class="flex flex-col gap-2 w-full">
                        <label for="startDate">Start Date</label>
                        <input type="date" id="startDate" formControlName="startDate"/>
                    </div>
                    <div class="flex flex-col gap-2 w-full">
                        <label for="endDate">End Date</label>
                        <input type="date" id="endDate"  formControlName="endDate"/>
                    </div>
                </div>
                <div class="flex flex-col gap-2 w-full mb-3">
                    <label for="location">Event Location</label>
                    <input id="location" formControlName="location" title="Adding a full address here will allow us to share a link to Google Maps" />
                    <small class="ms-6">Adding a full address here will allow us to share a link to Google Maps</small>
                </div>
                <div class="grid grid-cols-2">
                    <div>
                        <div class="flex flex-col gap-2 w-full mb-3">
                            <label for="location">Event Host</label>
                            <select formControlName="hostID">
                                @for(eventHost of (eventHosts$ | async); track eventHost){
                                    <option [ngValue]="eventHost.hostID" >{{ eventHost.name }}</option>
                                }
                            </select>
                        </div>  
                        <div class="flex flex-col gap-2 w-full">
                            <label for="location">Event Image</label>
                            <input type="file" id="location"  />
                        </div>
                    </div>
                    <div class="flex justify-center">
                        @if (lrpEvent.eventHost && lrpEvent.eventHost.img){
                            <img class="p-6 max-h-40 mix-blend-multiply" [src]="lrpEvent.eventHost.img.url" [alt]="'Logo for ' + lrpEvent.eventHost.name" [title]="lrpEvent.eventHost.name">
                        }
                    </div>
                </div>
                @if (isAdmin){
                    <div class="flex justify-between">
                        <h2 class="mt-3 text-lrpTicketRed">Organiser</h2>
                        <p class="text-lrpTicketRed mt-6">ADMINISTRATOR ONLY</p>
                    </div>
                    <hr class="mb-2 text-lrpTicketRed">
                    <div class="flex flex-col gap-2 w-full mb-3">
                        <label for="organiser">Event Organiser</label>
                        <select formControlName="organiserID">
                            @for(organiser of (organisers$ | async); track $index){
                                <option [ngValue]="organiser.organiserID" >{{ organiser.name }}</option>
                            }
                        </select>
                    </div>  
                }
                <h2 class="mt-3">Event Visibility</h2>
                <hr class="mb-2">
                <p class="text-sm mb-3">These two options can be used seperately, and control how your event can be accessed. Enabling either option will make the event accessible.</p>
                <div class="flex gap-3 mb-3">
                    <p-toggle-switch class="text-lrpTicketBlue" formControlName="advertised" /> 
                    <label for="">Advertise {{ detailsForm.controls['name'].value }}<br/><span class="text-xs">This will show your event on our front page listings</span></label>
                </div>
                <div class="flex gap-3">
                    <p-toggle-switch class="text-lrpTicketBlue" formControlName="allowBookings"/> 
                    <label for="">Allow Bookings for {{ detailsForm.controls['name'].value }}<br/><span class="text-xs">This allows people to being purchasing tickets for your events</span></label>
                </div>
            </div>
            <div class="w-full">
                <h2>Promotional Description</h2>
                <hr>
                <small>A short description of your event to hook in your players. This will be displayed on the advertising cards and links for your event.</small>
                <p-editor formControlName="promoDescription" />
                <h2 class="mt-3">In-Character Invitation</h2>
                <hr>
                <small>This should be the in-character blurb for why your players characters are attending the event. </small>
                <p-editor formControlName="icInvitation" />
                <h2 class="mt-3">Event Description</h2>
                <hr>
                <small>This section should contain all the pertinent information your attendees may need about your event.</small>
                <p-editor formControlName="eventDescription" />
            </div>
            <div>

            </div>
        </div>
        <div class="flex justify-end gap-3">
            <button class="outline-button w-32">Cancel</button>
            <button class="primaryButton w-32" (click)="saveDetails(lrpEvent)">Save</button>
        </div>
    }
</app-admin-boilerplate>
